async function fetchFaq({ endpoint, category, onlyLastFive, signal }) {
	const url = new URL(endpoint);
	if (category) url.searchParams.set('category', category);
	if (onlyLastFive) url.searchParams.set('onlyLastFive', '1');

	const res = await fetch(url.toString(), {
		method: 'GET',
		headers: { 'Accept': 'application/json' },
		signal,
	});

	if (!res.ok) throw new Error(`HTTP ${res.status}`);
	return res.json();
}

function initFaq(root) {
	const dataEl = root.getAttribute('data-kalelia-faq');
	if (!dataEl) return;

	let config;
	try { config = JSON.parse(dataEl); } catch (e) { return; }

	const endpoint = config.endpoint;
	const results = root.querySelector('[data-faq-results]');
	const catList = root.querySelector('[data-faq-cats]');
	const catButtons = catList ? Array.from(catList.querySelectorAll('[data-cat]')) : [];

	let controller = null;
	let currentCategory = config.initialCategory || '';

	const run = async () => {
		const category = currentCategory;

		if (controller) controller.abort();
		controller = new AbortController();

		root.classList.add('is-loading');
		try {
			const payload = await fetchFaq({
				endpoint,
				category,
				onlyLastFive: config.onlyLastFive,
				signal: controller.signal,
			});
			if (results) results.innerHTML = payload.html || '';
		} catch (err) {
			if (err.name !== 'AbortError') {
				// fallback minimal
				if (results) results.innerHTML = '<p class="kalelia-faq__error">Erreur lors du chargement.</p>';
			}
		} finally {
			root.classList.remove('is-loading');
		}
	};

	const updateActiveState = () => {
		catButtons.forEach((button) => {
			const targetCat = button.dataset.cat || '';
			const isActive = targetCat === currentCategory;
			button.classList.toggle('is-active', isActive);
			button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
		});
	};

	if (catList) {
		catList.addEventListener('click', (event) => {
			const button = event.target.closest('[data-cat]');
			if (!button || !catList.contains(button)) {
				return;
			}

			const nextCat = button.dataset.cat || '';
			if (nextCat === currentCategory) {
				return;
			}

			currentCategory = nextCat;
			updateActiveState();
			run();
		});

		updateActiveState();
	}
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.kalelia-faq[data-kalelia-faq]').forEach(initFaq);
});
